import $ from 'jquery';
import scrollLock from '../util/scrollLock';

function initLeftNavExpandableSections() {
  // From: https://css-tricks.com/using-css-transitions-auto-dimensions/#technique-3-javascript
  function animateOpen($section) {
    const scrollHeight = $section.get(0).scrollHeight;

    $section.on('transitionend', event => {
      $section
        .off(event)
        .css('height', null);
    });

    $section.css('height', `${scrollHeight}px`);
  }

  function animateClosed($section) {
    const transition = $section.css('transition');
    const scrollHeight = $section.get(0).scrollHeight;
    $section.css('transition', null);

    requestAnimationFrame(() => {
      $section.css({
        height: `${scrollHeight}px`,
        transition: transition,
      });

      requestAnimationFrame(() => {
        $section.css('height', 0);
      });
    });
  }

  const block = '.research-left-nav';
  const dataAttr = 'data-left-nav-section-display';

  // Collapse or expand the sections when they are clicked
  $(`${block}__expand-toggle`).click(function() {
    const $section = $(this).closest(`[${dataAttr}]`);
    const $subMenu = $section.find('.sub-menu');

    if ($section.attr(dataAttr) === 'visible') {
      animateClosed($subMenu);
      $section.attr(dataAttr, 'hidden');
    } else if ($section.attr(dataAttr) === 'hidden') {
      animateOpen($subMenu);
      $section.attr(dataAttr, 'visible');
    }
  });

  // Once on init, set the height of each open submenu to it's actual height. Animating from auto has issues.
  $(`[${dataAttr}="visible"] .sub-menu`).each((_, el) => {
    $(el).css('height', `${el.scrollHeight}px`);
  });
}

function initMobileLeftNav() {
  const $block = $('.research-left-nav');
  const $button = $('.research-left-nav-toggle');

  $button.click(() => {
    scrollLock.toggle();
    $block.toggleClass('research-left-nav--visible');
    $button.toggleClass('research-left-nav-toggle--nav-visible');
  });

  // When any link in the left nav is clicked it should hide the nav.
  // Some of the link are to ids on the same page
  $block.find('a').click(() => {
    if ($block.hasClass('research-left-nav--visible')) {
      scrollLock.enableScroll();
      $block.removeClass('research-left-nav--visible');
      $button.removeClass('research-left-nav-toggle--nav-visible');
    }
  });
}

// Function sets up an intersection observer to keep track of what section of the page is in view. When it changes
// we change the "active" menu item in the left nav.
function initActiveSectionHighlighting() {
  // specificity of selector is to help ensure the menu has the structure we expect
  const $subMenuItems = $('.research-left-nav__root > .current-menu-item.menu-item-has-children .sub-menu .menu-item a');
  let menuItemTargets = new Map();

  if (!$subMenuItems.length) {
    return console.log('Left nav menu structure is not valid, or current page does not have a menu item with children');
  }

  $subMenuItems.each((i, el) => {
    if (/#/.test(el.getAttribute('href'))) {
      const fragment = el.href.split('#')[1];
      const linkTargetEl = $(`#${fragment}`);

      if (!fragment || !linkTargetEl.length) {
        console.warn(`${fragment} was child of current menu item, but nothing with that ID was found on this page.`);
      } else {
        menuItemTargets.set(fragment, {
          link: linkTargetEl.get(0),
          menuItem: el,
        });
      }
    }
  });

  const observer = new IntersectionObserver((entries) => {
    for (let entry of entries) {
      // Only change the highlight when a new item isIntersecting
      if (entry.isIntersecting) {
        $subMenuItems.removeClass('research-left-nav__in-viewport-menu-item');
        $(menuItemTargets.get(entry.target.id).menuItem).addClass('research-left-nav__in-viewport-menu-item');
        return; // break after setting the first item  that is intersecting to "active"
      }
    }
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  });

  menuItemTargets.forEach(item => observer.observe(item.link));
}

export default {
  init() {
    if ($('.research-left-nav').length) {
      initLeftNavExpandableSections();
      initMobileLeftNav();
      initActiveSectionHighlighting();
    }
  },
  finalize() {},
};
